<div class="flex h-full flex-col overflow-hidden p-6 min-w-[320px] sm:min-w-[900px]">
  <div class="mb-4 flex items-center justify-between border-b pb-4">
    <h2 class="text-lg font-bold tracking-tight">Gestionar Grupos</h2>
    <button mat-icon-button type="button" (click)="close()"><mat-icon>close</mat-icon></button>
  </div>

  <div class="flex flex-col gap-4">
    <div class="flex items-center gap-2">
      <mat-form-field appearance="outline" class="min-w-[200px] flex-1" [subscriptSizing]="'dynamic'">
        <mat-label>Nuevo Grupo</mat-label>
        <input matInput [formControl]="newGroupNameControl" placeholder="Ej. Contacto" (keyup.enter)="addGroup()" />
      </mat-form-field>
      <button mat-flat-button color="primary" type="button" class="h-[52px]" (click)="addGroup()">Agregar</button>
    </div>

    <div *ngIf="errorMessage" class="rounded-lg bg-red-50 p-3 text-sm text-red-700">
      {{ errorMessage }}
    </div>

    <div class="max-h-[55vh] overflow-y-auto rounded-lg border">
      <div *ngIf="groups.length === 0" class="p-4 text-center text-sm text-gray-500">
        No hay grupos creados para este formulario.
      </div>

      <div
        *ngFor="let group of groups"
        class="grid grid-cols-1 items-start gap-3 border-b p-4 last:border-b-0 hover:bg-gray-50 sm:grid-cols-[minmax(0,1fr)_100px_minmax(0,240px)_minmax(0,240px)_auto]"
      >
        <mat-form-field appearance="outline" class="w-full" [subscriptSizing]="'dynamic'">
          <mat-label>Nombre</mat-label>
          <input matInput [ngModel]="group.name" (ngModelChange)="onNameChange(group, $event)" [ngModelOptions]="{ standalone: true }" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full" [subscriptSizing]="'dynamic'">
          <mat-label>Posición</mat-label>
          <input matInput type="number" [min]="MIN_POSITION" [ngModel]="group.position" (ngModelChange)="onPositionChange(group, $event)" [ngModelOptions]="{ standalone: true }" />
          <mat-hint *ngIf="isPositionInvalid(group)" class="text-red-600">La posición debe ser 1 o mayor.</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full" [subscriptSizing]="'dynamic'">
          <mat-label>Icono</mat-label>
          <mat-icon matPrefix class="mr-2 text-gray-600" [style.color]="group.iconColor || 'inherit'">
            {{ group.icon || 'help_outline' }}
          </mat-icon>
          <input
            matInput
            readonly
            [value]="group.icon || 'Ninguno'"
            [matMenuTriggerFor]="iconMenu"
            #iconMenuTrigger="matMenuTrigger"
            class="cursor-pointer font-medium text-gray-700"
          />
          <mat-icon matSuffix [matMenuTriggerFor]="iconMenu" class="cursor-pointer text-gray-400">
            arrow_drop_down
          </mat-icon>
        </mat-form-field>

        <mat-menu #iconMenu="matMenu" class="rounded-xl border shadow-lg">
          <div class="flex w-[260px] flex-col gap-2 p-3" (click)="$event.stopPropagation()">
            <div class="flex h-[36px] items-center rounded-lg border bg-gray-50 px-2">
              <mat-icon class="mr-1 text-sm text-gray-400">search</mat-icon>
              <input
                [formControl]="iconSearchControl"
                placeholder="Buscar icono..."
                class="w-full border-none bg-transparent text-xs text-gray-700 focus:outline-none"
              />
            </div>
            <button
              type="button"
              class="rounded-lg px-2 py-1 text-left text-xs text-gray-500 hover:bg-gray-100"
              (click)="selectIcon(group, null); iconMenuTrigger.closeMenu()"
            >
              Ninguno
            </button>
            <div class="grid max-h-[180px] grid-cols-5 gap-1.5 overflow-y-auto pr-1">
              <button
                *ngFor="let ic of filteredIcons$ | async"
                type="button"
                class="flex items-center justify-center rounded-lg border border-transparent p-2 transition-all hover:bg-gray-100"
                [class.bg-blue-50]="group.icon === ic"
                [class.border-blue-300]="group.icon === ic"
                (click)="selectIcon(group, ic); iconMenuTrigger.closeMenu()"
                [matTooltip]="ic"
              >
                <mat-icon class="text-gray-600">{{ ic }}</mat-icon>
              </button>
            </div>
          </div>
        </mat-menu>

        <mat-form-field appearance="outline" class="w-full" [subscriptSizing]="'dynamic'">
          <mat-label>Color Icono</mat-label>
          <span
            matPrefix
            class="ml-3 mr-2 block h-4 w-4 rounded-full border border-gray-300"
            [style.backgroundColor]="group.iconColor || 'transparent'"
          ></span>
          <mat-select
            #colorSelect
            [value]="group.iconColor"
            (selectionChange)="onColorSelect(group, $event.value, colorSelect, colorPicker)"
          >
            <mat-select-trigger>
              <ng-container *ngIf="!group.iconColor">Ninguno (Gris/Default)</ng-container>
              <ng-container *ngIf="group.iconColor">
                <ng-container *ngFor="let col of availableColors">
                  <ng-container *ngIf="col.value === group.iconColor">{{ col.name | titlecase }}</ng-container>
                </ng-container>
                <ng-container *ngIf="!isPresetColor(group.iconColor)">Personalizado</ng-container>
              </ng-container>
            </mat-select-trigger>
            <mat-option [value]="CUSTOM_COLOR">
              <div class="flex items-center gap-2 text-primary">
                <mat-icon class="mr-2 text-base">palette</mat-icon>
                <span>Elegir otro color...</span>
              </div>
            </mat-option>
            <mat-option [value]="null">Ninguno (Gris/Default)</mat-option>
            <mat-option *ngFor="let col of availableColors" [value]="col.value">
              <div class="flex items-center gap-2">
                <span class="mr-2 block h-4 w-4 rounded-full" [style.backgroundColor]="col.value"></span>
                <span>{{ col.name | titlecase }}</span>
              </div>
            </mat-option>
            <mat-option *ngIf="group.iconColor && !isPresetColor(group.iconColor)" [value]="group.iconColor">
              <div class="flex items-center gap-2">
                <span class="mr-2 block h-4 w-4 rounded-full" [style.backgroundColor]="group.iconColor"></span>
                <span>Personalizado</span>
              </div>
            </mat-option>
          </mat-select>
          <mat-icon
            matSuffix
            #colorPicker="ngxColorPicker"
            [colorPicker]="group.iconColor || '#000000'"
            (colorPickerSelect)="onCustomColorPicked(group, $event)"
            cpOutputFormat="hex"
            cpAlphaChannel="disabled"
            [cpOKButton]="true"
            cpOKButtonText="Aceptar"
            cpOKButtonClass="cp-btn-primary"
            [cpCancelButton]="true"
            cpCancelButtonText="Cancelar"
            cpCancelButtonClass="cp-btn-text"
            cpPosition="bottom"
            [cpUseRootViewContainer]="true"
            matTooltip="Elegir otro color..."
            class="mr-2 cursor-pointer text-gray-400"
          >
            palette
          </mat-icon>
        </mat-form-field>

        <div class="flex items-center gap-2 pt-2">
          <span *ngIf="fieldCount(group)" class="whitespace-nowrap text-xs text-gray-500" matTooltip="Campos asignados a este grupo">
            {{ fieldCount(group) }} campo(s)
          </span>
          <button mat-icon-button color="warn" type="button" (click)="removeGroup(group)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-4 flex justify-end gap-2 border-t pt-4">
    <button mat-button type="button" (click)="close()">Cerrar</button>
    <button mat-flat-button color="primary" type="button" (click)="save()">Guardar y Aplicar</button>
  </div>
</div>
